import { render, staticRenderFns } from "./OvertimeRequestRejected.vue?vue&type=template&id=f5d38048"
import script from "./OvertimeRequestRejected.vue?vue&type=script&lang=js"
export * from "./OvertimeRequestRejected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports